import React, { useRef, useEffect, useState } from "react";
import CSEBMobileImage1 from "../../images/mobile-01.png";
import CSEBMobileImage2 from "../../images/mobile-02.png";
import { motion, useTransform, useViewportScroll, useSpring } from 'framer-motion';

export default function CsMobileIntro(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 100;
  const ref = useRef([]);
  const elementRef = useRef();

  const setValues = () => {
    setElementTop(elementRef.current.offsetTop);
    setElementBottom(elementRef.current.offsetTop + elementRef.current.offsetHeight);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!elementRef.current) return;

    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const mobileTop = [elementTop, elementBottom];
  const y1 = useSpring(useTransform(scrollY, [mobileTop[0] - clientHeight * 1.2, mobileTop[0]], [yOffset, 0], "anticipate"),
    { damping: 40, stiffness: 500 });
  const y2 = useSpring(useTransform(scrollY, [mobileTop[1] - clientHeight * 1.2, mobileTop[1]], [yOffset, 0], "anticipate"),
    { damping: 40, stiffness: 500 });

  //console.log('banner state: ', elementTop, elementBottom, mobileTop);
  return (
    <div ref={elementRef} className="cs-mobile-intro-section section-gap" onLoad={() => { props.isLoaded && setValues(); }}>
      <div className="container">
        <div className="row d-flex flex-wrap align-v-center section-gap">
          <div className="col">
            <h3>New Experience!</h3>
            <p>Tech Savvy customers expect companies to offer personalized deals, coupons, and recommendations for a better and faster shopping experience. Customers can get customized promotions and discounts based on their past shopping behavior, enabling a better buying experience.</p>
          </div>
          <div ref={r => ref.current[0] = r} className="col text-center">
            <motion.img style={{ y: y1 }} src={CSEBMobileImage1} title="Personalized Shopping Experience" alt="digital experience" />
          </div>
        </div>

        <div className="row d-flex flex-wrap align-v-center">
          <div ref={r => ref.current[1] = r} style={{ y: y2 }} className="col text-center">
            <motion.img style={{ y: y2 }} src={CSEBMobileImage2} title="Online Grocery Shopping" alt="grocery shopping digital experience" />
          </div>
          <div className="col">
            <h3>Grocery shopping made easy</h3>
            <p>The savvy digital users can seamlessly shop between mobile and web apps - e.g. build their shopping lists, place delivery, and pick-up orders, refill their prescriptions, and redeem coupons.</p>
          </div>
        </div>
      </div>

    </div>
  );
}